import { isPS4Device } from '../../client/Player/utils/utils';
import { Device, MediaApiResponse } from '../../client/appTypings';
import { mediaApiUrl } from '../../client/environment';
import { isMediaItem } from '../../client/typeGuards';
import { rootApi } from '../rootApi';
import { Language } from '@yleisradio/areena-types';
import { Mode, teliaMode } from '../../common/types';

type MediaPayload = {
  languageCode: Language;
  countryCode: string | undefined;
  mode: Mode;
  id: string;
  device?: Device;
};

const audioLanguageMap = {
  fi: 'fin',
  sv: 'swe',
};

const mediaApi = rootApi.injectEndpoints({
  endpoints: build => ({
    getMedia: build.query<MediaApiResponse | undefined, MediaPayload>({
      query: payload => {
        const { model, family, hardware, capabilities, year } =
          payload.device ?? {};

        const isNativeTV = family === 'native';
        const isUhd = capabilities?.includes('UHD');
        const shouldUseMuxedAudio = payload.mode === teliaMode;

        const deviceInfo = isNativeTV
          ? `&`.concat(
              [
                `device_type=${payload.mode}`,
                `model_name=${model}`,
                `uhd=${isUhd}`,
                `firmware_version=${hardware}`,
                `year=${year}`,
              ].join('&')
            )
          : ``;

        const url = `${mediaApiUrl}${payload.id}/playouts.json?`
          .concat(`country=${payload.countryCode}`)
          .concat(
            shouldUseMuxedAudio
              ? `&AudioLang=${audioLanguageMap[payload.languageCode]}`
              : ``
          )
          .concat(
            isPS4Device(payload.device)
              ? `&muxed_audio=false&multiaudio_simulcast=true`
              : ``
          )
          .concat(deviceInfo);

        return { url };
      },
      providesTags: ['Media'],
      transformResponse: res => {
        if (isMediaItem(res)) {
          return res;
        }
      },
    }),
  }),
  overrideExisting: true,
});

export const { useGetMediaQuery } = mediaApi;

export { mediaApi };
